import { greekMessages } from '@/plugins/yup-localization';
import { BaseSchemaBuilder } from '@/views/checkouts/schemas/baseSchema';
import { isValidDate, singleAlphabet } from '@/views/checkouts/schemas/validators';
import * as yup from 'yup';

export const sharedEthnikiFields = (
  firstDriverAdditionalPremiumAge,
  secondDriverAdditionalPremiumAge,
  firstDriverAdditionalPremiumLicenseYears,
  secondDriverAdditionalPremiumLicenseYears,
  legalEntity,
  secondDriver,
  discountEntity,
  vehicleType
) => {
  let schema = {
    ...BaseSchemaBuilder(true, false, legalEntity, !legalEntity, discountEntity),
    tax_office: yup.string().required(),
    only_driver: yup.boolean().required(),
    co_owner: yup.boolean().required(),
  };

  if (legalEntity) {
    schema = {
      ...schema,
      ethniki_company_types: yup.string().required(),
    };
  } else {
    schema = {
      ...schema,
      name: singleAlphabet(schema.name),
      surname: singleAlphabet(schema.surname),
    };
  }

  if (firstDriverAdditionalPremiumLicenseYears) {
    schema = {
      ...schema,
      licenseIssueDate: yup.object({
        day: yup.string().required(),
        month: yup.string().required(),
        year: yup.string().required(),
      }).test('isValidDate', greekMessages.mixed.isValidDate, isValidDate).required(),
    };
  }

  if (secondDriverAdditionalPremiumLicenseYears) {
    schema = {
      ...schema,
      licenseIssueDate2: yup.object().when('only_driver', {
        is: false,
        then: s => s.shape({
          day: yup.string().required(),
          month: yup.string().required(),
          year: yup.string().required(),
        }).test('isValidDate', greekMessages.mixed.isValidDate, isValidDate),
      }),
    };
  }

  schema = {
    ...schema,
    name2: yup.string().when('only_driver', {
      is: false,
      then: (s) => s.required(),
    }),
    surname2: yup.string().when('only_driver', {
      is: false,
      then: (s) => s.required(),
    }),
  };


  return schema;
};


export const sharedEthnikiSchemaBuilder = (...args) => yup.object(sharedEthnikiFields(...args));
export default sharedEthnikiSchemaBuilder;
